<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">商务合同回款</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<Business v-if="activeIndex == 'list'" @isedit="isedit"></Business>
      </div>
    </div>
  </div>
</template>

<script>
import Business from './business/business.vue';//商务合同回款
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
	Business,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
	// 子传父回款认领
	isedit(val){
		console.log('我是传回来的id',val)
		this.activeIndex = 'claim'
	},
  },
};
</script>